import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


export default class ContentViewer extends Component {

constructor(props)
{
	console.log(props);
    super(props);
}

state = {
	ContentViewerObject: {},
     contentObjects: []
};

componentDidMount() 
{
	this.handleOnLoad();
}

handleOnLoad = () => {
  axios.get(`<http://os-dev.origosoftware.com:3000/ContentEditor/`).then(res => {
  const connectors = res.data;
  console.log(connectors);
  this.setState({ connectors });
  console.log(res.data[0]);
	});
	
}

render(){
return (
	<form>
		<div class="container-fluid">
			<div class="form-grid row">
			<h4>Content Viewer</h4>
				<a href="/content-editor" class="col-sm-2" >			
				Open In Editor
				</a>
			</div>
			<hr />

			<iframe width="890px" height="1000px" id="contentFrameImage" scrolling="yes" 
				frameborder="0" src="#{ombUserSession.getCurrentContentObjectPathAtMediaServerById(param['cid']) }" 				
			>	
			</iframe>	        
		</div>  

 </form> 
);
}
}